import React from 'react'
import LegalHeader from './LegalHeader'
import LegalEditor from './LegalEditor'
import LegalHost from './LegalHost'
import LegalIP from './LegalIP'
import LegalData from './LegalData'
import LegalResponsibility from './LegalResponsibility'
import LegalCookies from './LegalCookies'
import LegalLaw from './LegalLaw'
import NavBarHome from '../../components/NavBar/NavBarHome'
import Footer from '../../components/Footer/Footer'

function LegalNotice() {
   return (
      <div className="pt-[92px] flex flex-col min-h-screen">
         <NavBarHome />
         <LegalHeader />
         <LegalEditor />
         <LegalHost />
         <LegalIP />
         <LegalData />
         <LegalResponsibility />
         <LegalCookies />
         <LegalLaw />

         <Footer
            logo={"/Logo NextMaker.png"}
            bgColor="bg-dark-1"
            textColor="text-gray-100"
            borderColor="border-gray-400/20"
         />
      </div>
   )
}

export default LegalNotice